const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const formatNumber = (value) => {
  const n = Number.parseFloat(value || 0);
  return Number.isNaN(n) ? "0.00" : n.toFixed(2);
};

const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatInvoiceDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("ar-EG", { hour12: true });
};

const getOrderTypeLabel = (type) => {
  const map = {
    tables: "طاولات",
    delivery: "توصيل",
    takeaway: "استلام",
  };
  return map[type] || type || "-";
};

const getStatusLabel = (status) => {
  const map = {
    pending: "قيد الانتظار",
    finished: "منتهي",
    canceled: "ملغي",
    underway: "قيد التنفيذ",
    out_of_preparation: "خارج التحضير",
    delivered: "تم التوصيل",
    under_review: "قيد المراجعة",
  };
  return map[status] || status || "-";
};

const buildAmountRow = (label, amount, ratio) => {
  if (toNum(amount) <= 0) return "";
  const safeLabel = escapeHtml(label);
  const ratioText = toNum(ratio) > 0 ? ` (${formatNumber(ratio)}%)` : "";
  return `
    <div class="row">
      <span class="label">${safeLabel}${ratioText}</span>
      <span class="value num">${formatNumber(amount)} ج</span>
    </div>
  `;
};

const getBaseStyles = () => `
  @page {
    size: 80mm auto;
    margin: 0;
  }

  * {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    width: auto;
    min-width: 0;
    max-width: none;
    background: #fff;
    color: #000;
    font-family: Tahoma, Arial, sans-serif;
    font-size: 10px;
    line-height: 1.3;
    direction: rtl;
    overflow-x: hidden;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body {
    padding: 2mm;
  }

  .thermal-root {
    width: 100%;
    max-width: 74mm;
    margin: 0 auto;
    overflow: hidden;
  }

  .num {
    direction: ltr;
    unicode-bidi: isolate;
    white-space: nowrap;
    text-align: left;
    font-variant-numeric: tabular-nums;
  }

  .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 4px;
    align-items: start;
    min-width: 0;
  }

  .label {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .value {
    min-width: 0;
  }

  @media print {
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      width: auto !important;
      max-width: none !important;
      overflow-x: hidden !important;
    }

    body {
      padding: 2mm !important;
    }

    .thermal-root {
      width: 100% !important;
      max-width: 74mm !important;
      margin: 0 auto !important;
      overflow: hidden !important;
    }
  }
`;

const getReportStyles = () => `
  .report-wrap {
    border: 1px dashed #000;
    padding: 1.5mm;
    width: 100%;
    overflow: hidden;
  }

  .report-title {
    margin: 0;
    text-align: center;
    font-size: 12px;
    font-weight: 900;
  }

  .report-meta {
    margin: 2px 0 5px;
    text-align: center;
    font-size: 10px;
  }

  .summary {
    border: 1px dashed #000;
    padding: 4px;
    margin-bottom: 6px;
    overflow: hidden;
  }

  .summary .row {
    padding: 2px 0;
    border-bottom: 1px dashed #999;
  }

  .summary .row:last-child {
    border-bottom: 0;
  }

  .summary .label {
    font-weight: 800;
  }

  .summary .value {
    font-weight: 900;
    font-size: 10px;
  }

  .invoices-list {
    width: 100%;
    overflow: hidden;
  }

  .invoice-card {
    border: 1px dashed #000;
    padding: 4px;
    margin-bottom: 6px;
    page-break-inside: avoid;
    break-inside: avoid;
    overflow: hidden;
  }

  .invoice-card:last-child {
    margin-bottom: 0;
  }

  .invoice-head {
    padding-bottom: 3px;
    margin-bottom: 3px;
    border-bottom: 1px dashed #000;
  }

  .invoice-no {
    margin: 0;
    font-size: 11px;
    font-weight: 900;
    text-align: center;
  }

  .order-no {
    margin: 1px 0 0;
    font-size: 10px;
    text-align: center;
  }

  .meta-list {
    width: 100%;
    overflow: hidden;
  }

  .meta-line {
    padding: 2px 0;
    border-bottom: 1px dashed #b5b5b5;
  }

  .meta-line:last-child {
    border-bottom: 0;
  }

  .meta-line .label {
    font-weight: 800;
  }

  .meta-line .value {
    font-weight: 700;
    text-align: right;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .totals {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px dashed #000;
    width: 100%;
    overflow: hidden;
  }

  .totals .row {
    padding: 1px 0;
  }

  .totals .label {
    font-weight: 700;
  }

  .totals .value {
    font-weight: 800;
  }

  .grand-total {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 2px dashed #000;
  }

  .grand-total .label {
    font-size: 11px;
    font-weight: 900;
  }

  .grand-total .value {
    font-size: 12px;
    font-weight: 900;
  }

  .fallback-card {
    border: 1px dashed #000;
    padding: 6px;
    text-align: center;
    font-size: 10px;
    font-weight: 800;
  }
`;

const getSingleInvoiceStyles = () => `
  .invoice-card {
    border: 1px dashed #000;
    padding: 4px;
    width: 100%;
    overflow: hidden;
  }

  .invoice-head {
    padding-bottom: 3px;
    margin-bottom: 3px;
    border-bottom: 1px dashed #000;
  }

  .invoice-no {
    margin: 0;
    font-size: 11px;
    font-weight: 900;
    text-align: center;
  }

  .order-no {
    margin: 1px 0 0;
    font-size: 10px;
    text-align: center;
  }

  .meta-list {
    width: 100%;
    overflow: hidden;
  }

  .meta-line {
    padding: 2px 0;
    border-bottom: 1px dashed #b5b5b5;
  }

  .meta-line:last-child {
    border-bottom: 0;
  }

  .meta-line .label {
    font-weight: 800;
  }

  .meta-line .value {
    font-weight: 700;
    text-align: right;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .totals {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px dashed #000;
    width: 100%;
    overflow: hidden;
  }

  .totals .row {
    padding: 1px 0;
  }

  .totals .label {
    font-weight: 700;
  }

  .totals .value {
    font-weight: 800;
  }

  .grand-total {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 2px dashed #000;
  }

  .grand-total .label {
    font-size: 11px;
    font-weight: 900;
  }

  .grand-total .value {
    font-size: 12px;
    font-weight: 900;
  }
`;

const getAssetsWaitScript = () => `
  <script>
    async function waitForAssets() {
      try {
        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }
      } catch (e) {}

      const imgs = Array.from(document.images || []);
      await Promise.all(
        imgs.map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = () => resolve();
            img.onerror = () => resolve();
          });
        })
      );

      await new Promise((r) =>
        requestAnimationFrame(() => requestAnimationFrame(r))
      );
    }

    window.__waitForAssets = waitForAssets;
  </script>
`;

const normalizeInvoiceData = (orderDetails = {}, invoiceData = {}, orderId) => {
  const invoice =
    invoiceData && Object.keys(invoiceData).length ? invoiceData : orderDetails;

  const od = invoice?.order || (orderDetails?.order ? orderDetails.order : orderDetails);

  const items =
    invoice?.items ||
    invoice?.order_items ||
    od?.items ||
    od?.order_items ||
    orderDetails?.items ||
    [];

  const safeOrderId =
    orderId ?? od?.id ?? od?.order_id ?? invoice?.order_id ?? invoice?.id ?? "-";

  const safeGeneralIncrement = od?.general_increment ?? safeOrderId;
  const safeInvoiceNo = invoice?.id || "-";

  const user = invoice?.user || od?.user || {};
  const customer = od?.customer || {};

  const customerName = customer?.name || user?.name || od?.customer_name || "غير متوفر";
  const customerPhone = customer?.phone || user?.phone || od?.customer_phone || "-";
  const customerAddress =
    customer?.address || user?.address || od?.customer_address || "-";

  const tableName = od?.table?.name || "غير محددة";
  const tableNumber =
    od?.table?.number || od?.table_number || od?.table_no || od?.table_id || "-";

  const deliveryName =
    od?.delivery?.name ||
    od?.delivery_person?.name ||
    od?.driver?.name ||
    od?.delivery_name ||
    "غير محدد";

  const captainOrderName =
    invoice?.captain_order_name ||
    od?.captain_order_name ||
    od?.captain_order?.name ||
    od?.captain?.name ||
    (od?.captain_order_id ? `#${od.captain_order_id}` : "");

  const subtotalFromItems = items.reduce((acc, item) => {
    const qty = toNum(item.quantity);
    const price = item?.price ?? item?.unit_price;
    const totalValue = item?.total;

    const unit =
      price !== undefined && price !== null && price !== ""
        ? toNum(price)
        : qty && totalValue !== undefined && totalValue !== null && totalValue !== ""
          ? toNum(totalValue) / qty
          : 0;

    return acc + unit * qty;
  }, 0);

  const subtotal =
    invoice?.sub_total !== undefined && invoice?.sub_total !== null && invoice?.sub_total !== ""
      ? toNum(invoice.sub_total)
      : subtotalFromItems;

  const service = toNum(invoice?.service);
  const tax = toNum(invoice?.tax);
  const discount = toNum(invoice?.discount);
  const deliveryService = toNum(invoice?.delivery_service);

  const total =
    invoice?.total_amount !== undefined &&
    invoice?.total_amount !== null &&
    invoice?.total_amount !== ""
      ? toNum(invoice.total_amount)
      : subtotal + service + tax + deliveryService - discount;

  const serviceRatio = toNum(invoice?.service_ratio);
  const deliveryRatio = toNum(invoice?.delivery_service_ratio);
  const taxRatio = toNum(invoice?.tax_ratio);
  const discountRatio = toNum(invoice?.discount_ratio);

  const orderTypeLabel = getOrderTypeLabel(od?.order_type);
  const statusLabel = getStatusLabel(od?.status);

  const invoiceDate = formatInvoiceDate(
    invoice?.date ||
      invoice?.created_at ||
      od?.invoice_date ||
      od?.created_at ||
      od?.date
  );

  const metaRows = [
    ["العميل", customerName],
    ["نوع الطلب", orderTypeLabel],
    ["الحالة", statusLabel],
    ["التاريخ", invoiceDate],
    ["الهاتف", customerPhone],
    ["العنوان", customerAddress],
  ];

  if (od?.order_type === "tables") {
    metaRows.push(["الطاولة", `${tableName} (${tableNumber})`]);
  }

  if (od?.order_type === "delivery") {
    metaRows.push(["الدليفري", deliveryName]);
  }

  if (captainOrderName) {
    metaRows.push(["كابتن الأوردر", captainOrderName]);
  }

  return {
    safeInvoiceNo,
    safeGeneralIncrement,
    metaRows,
    subtotal,
    service,
    tax,
    discount,
    deliveryService,
    total,
    serviceRatio,
    deliveryRatio,
    taxRatio,
    discountRatio,
  };
};

const renderSingleInvoiceContent = (invoiceView) => {
  const {
    safeInvoiceNo,
    safeGeneralIncrement,
    metaRows,
    subtotal,
    service,
    tax,
    discount,
    deliveryService,
    total,
    serviceRatio,
    deliveryRatio,
    taxRatio,
    discountRatio,
  } = invoiceView;

  return `
    <section class="invoice-card">
      <div class="invoice-head">
        <p class="invoice-no">فاتورة رقم #${escapeHtml(safeInvoiceNo)}</p>
        <p class="order-no">طلب رقم #${escapeHtml(safeGeneralIncrement)}</p>
      </div>

      <div class="meta-list">
        ${metaRows
          .filter(([, value]) => value && String(value).trim() && String(value).trim() !== "-")
          .map(
            ([label, value]) => `
              <div class="meta-line row">
                <span class="label">${escapeHtml(label)}</span>
                <span class="value">${escapeHtml(value)}</span>
              </div>
            `
          )
          .join("")}
      </div>

      <div class="totals">
        <div class="row">
          <span class="label">الإجمالي الفرعي</span>
          <span class="value num">${formatNumber(subtotal)} ج</span>
        </div>

        ${buildAmountRow("الخدمة", service, serviceRatio)}
        ${buildAmountRow("التوصيل", deliveryService, deliveryRatio)}
        ${buildAmountRow("الضريبة", tax, taxRatio)}
        ${buildAmountRow("الخصم", discount, discountRatio)}
      </div>

      <div class="grand-total row">
        <span class="label">الإجمالي الكلي</span>
        <span class="value num">${formatNumber(total)} ج</span>
      </div>
    </section>
  `;
};

const renderSingleInvoiceDocument = (invoiceView) => {
  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8" />
      <style>
        ${getBaseStyles()}
        ${getSingleInvoiceStyles()}
      </style>
    </head>
    <body>
      <div class="thermal-root">
        ${renderSingleInvoiceContent(invoiceView)}
      </div>
      ${getAssetsWaitScript()}
    </body>
    </html>
  `;
};

const renderInvoicesReport = (invoices = []) => {
  const totalSales = invoices.reduce(
    (sum, inv) => sum + Number.parseFloat(inv?.total_amount || 0),
    0
  );

  const average = invoices.length ? totalSales / invoices.length : 0;
  const dateNow = new Date().toLocaleString("ar-EG", { hour12: true });

  const invoicesContent = invoices
    .map((invoice) => {
      try {
        const invoiceView = normalizeInvoiceData(
          invoice?.order || invoice,
          invoice,
          invoice?.order?.id || invoice?.order_id || invoice?.id
        );

        return renderSingleInvoiceContent(invoiceView);
      } catch (e) {
        const orderNo = escapeHtml(invoice?.order?.general_increment || "-");
        return `<div class="fallback-card">فاتورة #${orderNo}</div>`;
      }
    })
    .join("");

  return `
    <!doctype html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="utf-8" />
      <title>تقرير الفواتير</title>
      <style>
        ${getBaseStyles()}
        ${getReportStyles()}
      </style>
    </head>
    <body>
      <div class="thermal-root">
        <div class="report-wrap">
          <h2 class="report-title">تقرير الفواتير</h2>
          <div class="report-meta">تاريخ الطباعة: ${escapeHtml(dateNow)}</div>

          <div class="summary">
            <div class="row">
              <span class="label">عدد الفواتير</span>
              <span class="value num">${escapeHtml(invoices.length)}</span>
            </div>
            <div class="row">
              <span class="label">إجمالي المبيعات</span>
              <span class="value num">${escapeHtml(formatNumber(totalSales))}</span>
            </div>
            <div class="row">
              <span class="label">متوسط الفاتورة</span>
              <span class="value num">${escapeHtml(formatNumber(average))}</span>
            </div>
          </div>

          <div class="invoices-list">
            ${invoicesContent}
          </div>
        </div>
      </div>
      ${getAssetsWaitScript()}
    </body>
    </html>
  `;
};

export default async function PrintInvoices(
  orderDetails = {},
  invoiceData = {},
  orderId
) {
  if (Array.isArray(orderDetails?.invoices)) {
    return renderInvoicesReport(orderDetails.invoices);
  }

  const invoiceView = normalizeInvoiceData(orderDetails, invoiceData, orderId);
  return renderSingleInvoiceDocument(invoiceView);
}
